export * from "./admins";
export * from "./members";
export * from "./points";
export * from "./levels";
import * as ebookCompanies from "./ebook-companies";
import * as viewers from "./viewers";
import * as terms from "./terms";

export const user = {
    ...terms,
    ...viewers,
    ...ebookCompanies,
}